import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Grade } from 'src/model/Grade';
import { Product } from 'src/model/Product';
import { setLoading } from 'src/redux/loading/loadingSlice';
import { api } from 'src/services/api';
import { ProductManagerUI } from './ui';
import { EditProductScreen } from '../EditProduct';

type View = 'list' | 'edit';

export const ProductManagerScreen: React.FC = () => {
  const dispatch = useDispatch();
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string>('');
  const [view, setView] = useState<View>('list');

  const handleEdit = (id: string) => {
    if (!id) return;
    setSelectedProduct(id);
    setView('edit');
  };

  const handleBackToList = () => {
    setView('list');
    setSelectedProduct('');
    void getProduct();
  };

  const getProduct = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Product[]>('/product/find-store');
      if (response.status === 200) setProducts(response.data);
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleDelete = async (id: string): Promise<void> => {
    dispatch(setLoading(true));
    try {
      await api.get(`/product/delete/${id}`);
      await getProduct();
      toast.success('Produto deletado com sucesso');
    } catch {
      toast.error('Erro ao deletar o produto');
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleStock = (stock: Grade[]): number => {
    let total = 0;
    stock.forEach((g) =>
      g.gradeSizes.forEach((s) => {
        total += parseInt(s.stock);
      })
    );
    return total;
  };

  useEffect(() => {
    void getProduct();
  }, []);

  if (view === 'edit' && selectedProduct) {
    return (
      <EditProductScreen id={selectedProduct} onClose={handleBackToList} />
    );
  }

  return (
    <ProductManagerUI
      products={products}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleStock={handleStock}
    />
  );
};
